import type { TRuleWithTheme } from '@/styles/theme';

export const container: TRuleWithTheme = () => ({
    width: '100%',

    paddingTop: '0.75rem',
});

export const list: TRuleWithTheme = () => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '0.75rem',
});
